import { useEffect } from 'react'
import { useFixedAssetsNavStore } from '@/store/fixedAssetsNavStore'

/**
 * Seeds Fixed Assets left-nav incomplete month count from the cached nav-status snapshot.
 */
export function useFixedAssetsNavStatusPoller() {
  const fetchNavStatus = useFixedAssetsNavStore((s) => s.fetchNavStatus)

  useEffect(() => {
    void fetchNavStatus()
  }, [fetchNavStatus])
}
